module.exports = __webpack_public_path__ + "static/OneDot.00e902d8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/OneDot.woff
// module id = 736
// module chunks = 114276838955818